export const MONTHS_PER_YEAR = 12
